module.exports = __webpack_public_path__ + "img/physical-facilities.09614705.svg";